<script setup lang="ts">
</script>

<template>
	<div class="flex flex-col items-center">
		<DmLogo class="h-16 mb-8" />
		<OmnectHeading class="text-primary" :title="$t('statusCodes.404')" size="3xl" />
		<img alt="404 image" class="w-128" src="/404.png">
		<UButton data-cy="to-start-page" color="secondary" to="/">
			{{ $t('common.toStartPage') }}
		</UButton>
	</div>
</template>
